(function () {
  'use strict';

  /* ============================================================
     Utilities
     ============================================================ */

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function clearElement(el) {
    while (el.firstChild) el.removeChild(el.firstChild);
  }

  /* ============================================================
     API Helper
     ============================================================ */

  var API_BASE = 'https://bb-gift-registry.vercel.app/api/registry';

  function getCustomerAuth() {
    var el = document.getElementById('registryCustomerAuth');
    if (!el) return {};
    return {
      'X-Customer-Id': el.dataset.customerId || '',
      'X-Customer-Token': el.dataset.customerToken || ''
    };
  }

  function registryFetch(path, options) {
    options = options || {};
    var url = API_BASE + path;
    var authHeaders = getCustomerAuth();
    var defaults = {
      headers: Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, authHeaders),
      credentials: 'include'
    };
    var merged = Object.assign({}, defaults, options);
    if (options.headers) {
      merged.headers = Object.assign({}, defaults.headers, options.headers);
    }
    return fetch(url, merged).then(function (res) {
      if (!res.ok) {
        return res.json().then(function (data) {
          throw data;
        });
      }
      return res.json();
    });
  }

  /* ============================================================
     Registry Form (Multi-step create / edit)
     ============================================================ */

  function initRegistryForm() {
    var container = document.getElementById('registryFormApp');
    if (!container) return;

    var totalSteps = 6;
    var currentStep = 1;
    var formData = {};

    var params = new URLSearchParams(window.location.search);
    var editId = params.get('registry_id');
    var isEdit = !!editId;

    function renderStepIndicator() {
      var stepEls = container.querySelectorAll('.registry-step');
      var lineEls = container.querySelectorAll('.registry-step__line');
      stepEls.forEach(function (el, idx) {
        var stepNum = idx + 1;
        var circle = el.querySelector('.registry-step__circle');
        el.classList.remove('active', 'completed');
        if (stepNum === currentStep) {
          el.classList.add('active');
          if (circle) circle.textContent = stepNum;
        } else if (stepNum < currentStep) {
          el.classList.add('completed');
          if (circle) circle.textContent = '✓';
        } else {
          if (circle) circle.textContent = stepNum;
        }
      });
      lineEls.forEach(function (el, idx) {
        if (idx < currentStep - 1) {
          el.classList.add('completed');
        } else {
          el.classList.remove('completed');
        }
      });
    }

    function renderReview() {
      gatherFields();
      var reviewEl = container.querySelector('#registryReview');
      if (!reviewEl) return;

      var typeLabels = { wedding: 'Wedding Registry', baby: 'Baby Registry', general: 'General Registry' };

      var html = '';
      // Type
      html += '<div class="registry-review__section">';
      html += '<div class="registry-review__section-title">Registry Type</div>';
      html += '<div class="registry-review__row"><span class="registry-review__label">Type</span><span class="registry-review__value">' + escapeHtml(typeLabels[formData.type] || formData.type || '—') + '</span></div>';
      html += '</div>';

      // Details
      html += '<div class="registry-review__section">';
      html += '<div class="registry-review__section-title">Details</div>';
      html += '<div class="registry-review__row"><span class="registry-review__label">Title</span><span class="registry-review__value">' + escapeHtml(formData.title || '—') + '</span></div>';
      html += '<div class="registry-review__row"><span class="registry-review__label">Event Date</span><span class="registry-review__value">' + escapeHtml(formData.event_date || '—') + '</span></div>';
      if (formData.description) {
        html += '<div class="registry-review__row"><span class="registry-review__label">Description</span><span class="registry-review__value">' + escapeHtml(formData.description) + '</span></div>';
      }
      html += '</div>';

      // People
      html += '<div class="registry-review__section">';
      html += '<div class="registry-review__section-title">People</div>';
      html += '<div class="registry-review__row"><span class="registry-review__label">Registrant</span><span class="registry-review__value">' + escapeHtml(formData.registrant_name || '—') + '</span></div>';
      if (formData.co_registrant_name) {
        html += '<div class="registry-review__row"><span class="registry-review__label">Co-Registrant</span><span class="registry-review__value">' + escapeHtml(formData.co_registrant_name) + '</span></div>';
      }
      html += '<div class="registry-review__row"><span class="registry-review__label">Email</span><span class="registry-review__value">' + escapeHtml(formData.registrant_email || '—') + '</span></div>';
      html += '</div>';

      // Shipping
      html += '<div class="registry-review__section">';
      html += '<div class="registry-review__section-title">Shipping Address</div>';
      var addr = [formData.shipping_name, formData.shipping_address1, formData.shipping_address2, formData.shipping_city, formData.shipping_province, formData.shipping_zip, formData.shipping_country].filter(Boolean).join(', ');
      html += '<div class="registry-review__row"><span class="registry-review__label">Address</span><span class="registry-review__value">' + escapeHtml(addr || '—') + '</span></div>';
      html += '</div>';

      // Privacy
      html += '<div class="registry-review__section">';
      html += '<div class="registry-review__section-title">Privacy</div>';
      html += '<div class="registry-review__row"><span class="registry-review__label">Show Address</span><span class="registry-review__value">' + (formData.show_shipping_address ? 'Yes' : 'No') + '</span></div>';
      html += '<div class="registry-review__row"><span class="registry-review__label">Password Protected</span><span class="registry-review__value">' + (formData.enable_password ? 'Yes' : 'No') + '</span></div>';
      html += '</div>';

      reviewEl.innerHTML = html;
    }

    function showStep(step) {
      currentStep = step;
      var steps = container.querySelectorAll('.registry-form__step');
      steps.forEach(function (el) {
        el.style.display = 'none';
      });
      var target = container.querySelector('.registry-form__step[data-step="' + step + '"]');
      if (target) target.style.display = '';
      if (step === 6) renderReview();
      renderStepIndicator();
    }

    function gatherFields() {
      var inputs = container.querySelectorAll('input, select, textarea');
      inputs.forEach(function (el) {
        if (el.name) {
          if (el.type === 'radio') {
            if (el.checked) formData[el.name] = el.value;
          } else if (el.type === 'checkbox') {
            formData[el.name] = el.checked;
          } else {
            formData[el.name] = el.value;
          }
        }
      });
    }

    function validate() {
      var step = container.querySelector('.registry-form__step[data-step="' + currentStep + '"]');
      if (!step) return true;
      var required = step.querySelectorAll('[required]');
      var valid = true;
      var checkedRadioNames = {};
      required.forEach(function (el) {
        if (el.type === 'radio') {
          if (checkedRadioNames[el.name] !== undefined) return;
          var anyChecked = step.querySelector('input[name="' + el.name + '"]:checked');
          checkedRadioNames[el.name] = !!anyChecked;
          if (!anyChecked) {
            var radios = step.querySelectorAll('input[name="' + el.name + '"]');
            radios.forEach(function (r) { r.style.outlineColor = '#d32f2f'; r.style.outline = '2px solid #d32f2f'; });
            valid = false;
          } else {
            var radios = step.querySelectorAll('input[name="' + el.name + '"]');
            radios.forEach(function (r) { r.style.outline = ''; });
          }
        } else {
          if (!el.value || !el.value.trim()) {
            el.style.borderColor = '#d32f2f';
            valid = false;
          } else {
            el.style.borderColor = '';
          }
        }
      });
      return valid;
    }

    var isSubmitting = false;

    function submit() {
      if (isSubmitting) return;
      isSubmitting = true;

      /* Show loading state on submit button */
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalText = submitBtn.textContent;
        submitBtn.textContent = isEdit ? 'Updating...' : 'Creating...';
        submitBtn.classList.add('btn--loading');
      }

      gatherFields();
      var method = isEdit ? 'PUT' : 'POST';
      var path = isEdit ? '/registries/' + editId : '/registries';
      registryFetch(path, {
        method: method,
        body: JSON.stringify(formData)
      }).then(function (data) {
        var msg = container.querySelector('.registry-form__message');
        if (msg) {
          if (isEdit) {
            msg.textContent = 'Registry updated!';
          } else {
            msg.textContent = 'Registry created! ';
            var link = document.createElement('a');
            link.href = '/pages/my-registries';
            link.textContent = 'View My Registries \u2192';
            link.style.cssText = 'color:#143f2f;font-weight:700;text-decoration:underline;';
            msg.appendChild(link);
          }
          msg.style.display = '';
        }
        /* Hide the entire nav bar (Back + Create button) on success */
        var navBar = container.querySelector('.registry-form__nav');
        if (navBar) navBar.style.display = 'none';
      }).catch(function (err) {
        var msg = container.querySelector('.registry-form__message');
        if (msg) {
          msg.textContent = (err && err.error) || 'Something went wrong.';
          msg.style.display = '';
          msg.style.background = '#fef2f2';
          msg.style.borderColor = '#d32f2f';
          msg.style.color = '#d32f2f';
        }
        /* Re-enable button on error so they can retry */
        isSubmitting = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || (isEdit ? 'Update Registry' : 'Create Registry');
          submitBtn.classList.remove('btn--loading');
        }
      });
    }

    if (isEdit) {
      registryFetch('/registries/' + editId).then(function (data) {
        if (data) {
          Object.keys(data).forEach(function (key) {
            var el = container.querySelector('[name="' + key + '"]');
            if (el) {
              if (el.type === 'checkbox') el.checked = !!data[key];
              else if (el.type === 'radio') {
                var radio = container.querySelector('[name="' + key + '"][value="' + data[key] + '"]');
                if (radio) radio.checked = true;
              } else {
                el.value = data[key];
              }
            }
          });
        }
      });
    }

    var nextBtn = container.querySelector('#nextStep');
    var prevBtn = container.querySelector('#prevStep');
    var submitBtn = container.querySelector('#submitRegistry');

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        gatherFields();
        if (validate()) {
          showStep(currentStep + 1);
          prevBtn.style.display = '';
          if (currentStep === totalSteps) {
            nextBtn.style.display = 'none';
            submitBtn.style.display = '';
          }
        }
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        gatherFields();
        showStep(currentStep - 1);
        nextBtn.style.display = '';
        submitBtn.style.display = 'none';
        if (currentStep === 1) {
          prevBtn.style.display = 'none';
        }
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function (e) {
        e.preventDefault();
        gatherFields();
        if (validate()) submit();
      });
    }

    showStep(1);
  }

  /* ============================================================
     My Registries (Manage)
     ============================================================ */

  function initRegistryManage() {
    var container = document.getElementById('registryManageApp');
    if (!container) return;

    var listEl = container.querySelector('.registry-manage__list');
    if (!listEl) return;

    function load() {
      registryFetch('/registries').then(function (data) {
        render(data.registries || data);
      }).catch(function () {
        listEl.textContent = 'Unable to load registries.';
      });
    }

    function render(registries) {
      clearElement(listEl);
      if (!registries || registries.length === 0) {
        listEl.textContent = 'You have no registries yet.';
        return;
      }
      registries.forEach(function (reg) {
        var card = document.createElement('div');
        card.className = 'registry-card';

        var info = document.createElement('div');
        var title = document.createElement('strong');
        title.textContent = reg.title || 'Untitled';
        info.appendChild(title);

        var badge = document.createElement('span');
        badge.className = 'registry-card__badge';
        badge.textContent = reg.type || 'registry';
        info.appendChild(document.createTextNode(' '));
        info.appendChild(badge);

        var status = document.createElement('span');
        status.className = 'registry-card__status ' + (reg.is_published ? 'published' : 'draft');
        status.textContent = reg.is_published ? 'Published' : 'Draft';
        info.appendChild(document.createTextNode(' '));
        info.appendChild(status);

        card.appendChild(info);

        var actions = document.createElement('div');
        actions.className = 'registry-card__actions';

        var itemsBtn = document.createElement('button');
        itemsBtn.className = 'btn btn--small';
        itemsBtn.type = 'button';
        itemsBtn.textContent = 'Manage Items (' + (reg.item_count || 0) + ')';
        actions.appendChild(itemsBtn);

        var editBtn = document.createElement('a');
        editBtn.className = 'btn btn--small';
        editBtn.href = '/pages/create-a-registry?registry_id=' + encodeURIComponent(reg.id);
        editBtn.textContent = 'Edit Details';
        editBtn.title = 'Edit registry name, date, and shipping address';
        actions.appendChild(editBtn);

        var shareBtn = document.createElement('button');
        shareBtn.className = 'btn btn--small' + (reg.is_published ? '' : ' btn--disabled');
        shareBtn.type = 'button';
        shareBtn.textContent = 'Share';
        if (reg.is_published) {
          (function (slug) {
            shareBtn.addEventListener('click', function () { window.registryShare(slug); });
          })(reg.slug || '');
        } else {
          shareBtn.disabled = true;
          shareBtn.title = 'Publish this registry before sharing';
        }
        actions.appendChild(shareBtn);

        var viewBtn = document.createElement('a');
        viewBtn.className = 'btn btn--small' + (reg.is_published ? '' : ' btn--disabled');
        if (reg.is_published) {
          viewBtn.href = '/pages/view-registry?slug=' + encodeURIComponent(reg.slug || '');
        } else {
          viewBtn.title = 'Publish this registry before viewing';
          viewBtn.style.pointerEvents = 'none';
        }
        viewBtn.textContent = 'View';
        actions.appendChild(viewBtn);

        var pubBtn = document.createElement('button');
        pubBtn.className = 'btn btn--small';
        pubBtn.type = 'button';
        pubBtn.textContent = reg.is_published ? 'Unpublish' : 'Publish';
        (function (id, nextState) {
          pubBtn.addEventListener('click', function () { window.registryTogglePublish(id, nextState); });
        })(reg.id, !reg.is_published);
        actions.appendChild(pubBtn);

        var delBtn = document.createElement('button');
        delBtn.className = 'btn btn--small';
        delBtn.type = 'button';
        delBtn.textContent = 'Delete';
        (function (id) {
          delBtn.addEventListener('click', function () { window.registryDelete(id); });
        })(reg.id);
        actions.appendChild(delBtn);

        card.appendChild(actions);

        /* State-aware next steps guide — shown for every card */
        var nextSteps = document.createElement('div');
        nextSteps.className = 'registry-card__next-steps';

        var nsTitle = document.createElement('strong');
        var guideTitle;
        var steps;
        var hasItems = (reg.item_count || 0) > 0;

        if (!reg.is_published && !hasItems) {
          guideTitle = 'Next Steps to Get Your Registry Ready';
          steps = [
            { num: '1', text: 'Browse the store and add products using the "\u2665 Add to Registry" button on any product page.', done: false },
            { num: '2', text: 'Review your items by clicking "Manage Items" above. Remove anything you don\'t need.', done: false },
            { num: '3', text: 'Click "Publish" above to make your registry visible. Share and View will become available once published.', done: false }
          ];
        } else if (!reg.is_published && hasItems) {
          guideTitle = 'Almost There — Publish Your Registry';
          steps = [
            { num: '1', text: 'Browse the store and add products using the "\u2665 Add to Registry" button on any product page.', done: true },
            { num: '2', text: 'Review your items by clicking "Manage Items" above. Remove anything you don\'t need.', done: false },
            { num: '3', text: 'Click "Publish" above to make your registry visible. Share and View will become available once published.', done: false }
          ];
        } else {
          guideTitle = 'Your Registry is Live';
          steps = [
            { num: '1', text: 'Click "Share" above to copy the link and send it to friends and family.', done: false },
            { num: '2', text: 'Click "View" to see your registry the way gifters will see it.', done: false },
            { num: '3', text: 'You can still add items from any product page or use "Manage Items" to edit the list. Use "Unpublish" to pause visibility at any time.', done: false }
          ];
        }

        nsTitle.textContent = guideTitle;
        nextSteps.appendChild(nsTitle);

        steps.forEach(function (step) {
          var stepEl = document.createElement('div');
          stepEl.className = 'registry-card__next-step' + (step.done ? ' registry-card__next-step--done' : '');

          var num = document.createElement('span');
          num.className = 'registry-card__step-num';
          num.textContent = step.done ? '\u2713' : step.num;
          stepEl.appendChild(num);

          var text = document.createElement('span');
          text.textContent = step.text;
          stepEl.appendChild(text);

          nextSteps.appendChild(stepEl);
        });

        card.appendChild(nextSteps);

        /* Items panel (hidden by default) */
        var itemsPanel = document.createElement('div');
        itemsPanel.className = 'registry-card__items';
        itemsPanel.style.display = 'none';
        card.appendChild(itemsPanel);

        (function (registryId, panel, btn) {
          btn.addEventListener('click', function () {
            if (panel.style.display === 'none') {
              panel.style.display = '';
              panel.textContent = 'Loading items...';
              btn.textContent = 'Hide Items';
              registryFetch('/registries/' + registryId).then(function (data) {
                var reg = data.registry || data;
                var items = reg.items || [];
                clearElement(panel);
                if (items.length === 0) {
                  panel.textContent = 'No items in this registry.';
                  return;
                }
                items.forEach(function (item) {
                  var row = document.createElement('div');
                  row.className = 'registry-card__item-row';

                  if (item.image_url) {
                    var img = document.createElement('img');
                    img.src = item.image_url;
                    img.alt = '';
                    img.className = 'registry-card__item-img';
                    row.appendChild(img);
                  }

                  var info = document.createElement('div');
                  info.className = 'registry-card__item-info';
                  var name = document.createElement('strong');
                  name.textContent = item.title || 'Untitled';
                  info.appendChild(name);
                  if (item.variant_title && item.variant_title !== 'Default Title') {
                    var vt = document.createElement('span');
                    vt.className = 'registry-card__item-variant';
                    vt.textContent = item.variant_title;
                    info.appendChild(vt);
                  }
                  row.appendChild(info);

                  var removeBtn = document.createElement('button');
                  removeBtn.className = 'registry-card__item-remove';
                  removeBtn.type = 'button';
                  removeBtn.textContent = 'Remove';
                  removeBtn.title = 'Remove from registry';
                  (function (rId, iId, rowEl) {
                    removeBtn.addEventListener('click', function () {
                      if (!confirm('Remove "' + (item.title || '') + '" from this registry?')) return;
                      registryFetch('/registries/' + rId + '/items/' + iId, { method: 'DELETE' }).then(function () {
                        rowEl.remove();
                        /* Update items count on button */
                        var remaining = panel.querySelectorAll('.registry-card__item-row').length;
                        if (remaining === 0) panel.textContent = 'No items in this registry.';
                      });
                    });
                  })(registryId, item.id, row);
                  row.appendChild(removeBtn);

                  panel.appendChild(row);
                });
              }).catch(function () {
                panel.textContent = 'Failed to load items.';
              });
            } else {
              panel.style.display = 'none';
              btn.textContent = 'Manage Items (' + (reg.item_count || 0) + ')';
            }
          });
        })(reg.id, itemsPanel, itemsBtn);

        listEl.appendChild(card);
      });
    }

    window.registryShare = function (slug) {
      var url = window.location.origin + '/pages/view-registry?slug=' + encodeURIComponent(slug);
      var overlay = document.createElement('div');
      overlay.className = 'registry-modal';
      var content = document.createElement('div');
      content.className = 'registry-modal__content';

      var close = document.createElement('button');
      close.className = 'registry-modal__close';
      close.type = 'button';
      close.textContent = '\u00D7';
      close.addEventListener('click', function () { overlay.remove(); });
      content.appendChild(close);

      var h3 = document.createElement('h3');
      h3.textContent = 'Share Registry';
      content.appendChild(h3);

      var shareRow = document.createElement('div');
      shareRow.className = 'registry-modal__share-url';
      var input = document.createElement('input');
      input.type = 'text';
      input.readOnly = true;
      input.value = url;
      shareRow.appendChild(input);
      var copyBtn = document.createElement('button');
      copyBtn.className = 'btn btn--small';
      copyBtn.type = 'button';
      copyBtn.textContent = 'Copy';
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(url).then(function () { copyBtn.textContent = 'Copied!'; });
      });
      shareRow.appendChild(copyBtn);
      content.appendChild(shareRow);

      overlay.appendChild(content);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
      document.body.appendChild(overlay);
    };

    window.registryTogglePublish = function (id, publish) {
      registryFetch('/registries/' + id, {
        method: 'PUT',
        body: JSON.stringify({ is_published: publish })
      }).then(function () { load(); });
    };

    window.registryDelete = function (id) {
      if (!confirm('Delete this registry?')) return;
      registryFetch('/registries/' + id, { method: 'DELETE' }).then(function () { load(); });
    };

    load();
  }

  /* ============================================================
     Find Registry
     ============================================================ */

  function initRegistryFind() {
    var container = document.getElementById('registryFindApp');
    if (!container) return;

    var form = container.querySelector('.registry-find__form');
    var resultsEl = container.querySelector('.registry-find__results');
    var paginationEl = container.querySelector('.registry-find__pagination');
    var debounceTimer = null;
    var currentPage = 1;

    function search(page) {
      page = page || 1;
      currentPage = page;
      var q = container.querySelector('.registry-find__search-input');
      var typeSelect = container.querySelector('[name="type"]');
      var query = q ? q.value : '';
      var type = typeSelect ? typeSelect.value : '';
      var qParams = '?q=' + encodeURIComponent(query) + '&page=' + page;
      if (type) qParams += '&type=' + encodeURIComponent(type);

      registryFetch('/search' + qParams).then(function (data) {
        renderResults(data.registries || data.results || []);
        renderPagination(data);
      }).catch(function () {
        if (resultsEl) resultsEl.textContent = 'Search failed.';
      });
    }

    function renderResults(registries) {
      if (!resultsEl) return;
      clearElement(resultsEl);
      if (!registries || registries.length === 0) {
        resultsEl.textContent = 'No registries found.';
        return;
      }
      var grid = document.createElement('div');
      grid.className = 'grid';
      registries.forEach(function (reg) {
        var col = document.createElement('div');
        col.className = 'grid__item medium-up--one-third';

        var card = document.createElement('a');
        card.className = 'registry-search-card';
        card.href = '/pages/view-registry?slug=' + encodeURIComponent(reg.slug || '');

        if (reg.cover_image) {
          var img = document.createElement('img');
          img.src = reg.cover_image;
          img.alt = escapeHtml(reg.title || '');
          card.appendChild(img);
        }

        var badge = document.createElement('span');
        badge.className = 'registry-search-card__badge';
        badge.textContent = reg.type || 'registry';
        card.appendChild(badge);

        var title = document.createElement('strong');
        title.textContent = reg.title || 'Untitled';
        card.appendChild(document.createElement('br'));
        card.appendChild(title);

        if (reg.event_date) {
          var date = document.createElement('span');
          date.textContent = reg.event_date;
          card.appendChild(document.createElement('br'));
          card.appendChild(date);
        }

        col.appendChild(card);
        grid.appendChild(col);
      });
      resultsEl.appendChild(grid);
    }

    function renderPagination(data) {
      if (!paginationEl) return;
      clearElement(paginationEl);
      var total = data.total_pages || data.totalPages || 0;
      if (total <= 1) return;
      for (var i = 1; i <= total; i++) {
        var btn = document.createElement('button');
        btn.className = 'btn btn--small' + (i === currentPage ? ' active' : '');
        btn.type = 'button';
        btn.textContent = i;
        btn.dataset.page = i;
        paginationEl.appendChild(btn);
      }
    }

    if (paginationEl) {
      paginationEl.addEventListener('click', function (e) {
        if (e.target.dataset.page) search(parseInt(e.target.dataset.page, 10));
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        search(1);
      });

      var searchInput = container.querySelector('.registry-find__search-input');
      if (searchInput) {
        searchInput.addEventListener('input', function () {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () { search(1); }, 400);
        });
      }
    }
  }

  /* ============================================================
     View Registry
     ============================================================ */

  function initRegistryView() {
    var container = document.getElementById('registryViewApp');
    if (!container) return;

    var params = new URLSearchParams(window.location.search);
    var slug = params.get('slug');
    if (!slug) return;

    var passwordGate = document.getElementById('registryPasswordGate');
    var mainContent = document.getElementById('registryContent');
    var registryData = null;
    var activeFilter = 'all';

    var loadingEl = document.getElementById('registryLoading');
    var notFoundEl = document.getElementById('registryNotFound');

    function hideLoading() {
      if (loadingEl) loadingEl.style.display = 'none';
    }

    function loadRegistry(password) {
      var path = '/r/' + encodeURIComponent(slug);
      if (password) path += '?password=' + encodeURIComponent(password);

      registryFetch(path).then(function (data) {
        hideLoading();
        registryData = data;
        if (data.locked) {
          if (passwordGate) passwordGate.style.display = '';
          if (mainContent) mainContent.style.display = 'none';
          return;
        }
        if (passwordGate) passwordGate.style.display = 'none';
        if (mainContent) mainContent.style.display = '';
        var reg = data.registry || data;
        renderHeader(reg);
        renderItems(data.items || []);
        renderCartActions();
      }).catch(function (err) {
        hideLoading();
        if (err && err.error === 'Registry not found') {
          if (notFoundEl) notFoundEl.style.display = '';
        } else if (err && err.password_required) {
          if (passwordGate) passwordGate.style.display = '';
          if (mainContent) mainContent.style.display = 'none';
        } else {
          if (notFoundEl) notFoundEl.style.display = '';
        }
      });
    }

    if (passwordGate) {
      var pwForm = passwordGate.querySelector('form');
      if (pwForm) {
        pwForm.addEventListener('submit', function (e) {
          e.preventDefault();
          var pw = passwordGate.querySelector('input[type="password"]');
          loadRegistry(pw ? pw.value : '');
        });
      }
    }

    function renderHeader(reg) {
      var header = container.querySelector('.registry-view__header');
      if (!header) return;
      clearElement(header);

      if (reg.cover_image_url) {
        var coverWrap = document.createElement('div');
        coverWrap.className = 'registry-view__cover';
        var img = document.createElement('img');
        img.src = reg.cover_image_url;
        img.alt = escapeHtml(reg.title || '');
        coverWrap.appendChild(img);
        header.appendChild(coverWrap);
      }

      var info = document.createElement('div');
      info.className = 'registry-view__info';
      var badge = document.createElement('span');
      badge.className = 'registry-view__badge';
      badge.textContent = reg.type || 'registry';
      info.appendChild(badge);

      var h1 = document.createElement('h1');
      h1.className = 'h2';
      h1.textContent = reg.title || '';
      info.appendChild(h1);

      if (reg.registrant_name) {
        var names = document.createElement('p');
        names.className = 'registry-view__names';
        names.textContent = reg.registrant_name + (reg.co_registrant_name ? ' & ' + reg.co_registrant_name : '');
        info.appendChild(names);
      }

      if (reg.event_date) {
        var date = document.createElement('p');
        date.className = 'registry-view__date';
        date.textContent = new Date(reg.event_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
        info.appendChild(date);
      }

      if (reg.description) {
        var desc = document.createElement('div');
        desc.className = 'rte';
        desc.textContent = reg.description;
        info.appendChild(desc);
      }

      header.appendChild(info);
    }

    function renderFilters() {
      var filtersEl = container.querySelector('.registry-view__filters');
      if (!filtersEl) return;
      clearElement(filtersEl);
      var filters = ['All', 'Needed', 'Fulfilled'];
      filters.forEach(function (label) {
        var btn = document.createElement('button');
        btn.className = 'btn btn--small' + (activeFilter === label.toLowerCase() ? ' active' : '');
        btn.type = 'button';
        btn.textContent = label;
        btn.addEventListener('click', function () {
          activeFilter = label.toLowerCase();
          renderFilters();
          renderItems(registryData ? registryData.items || [] : []);
        });
        filtersEl.appendChild(btn);
      });
    }

    function renderItems(items) {
      renderFilters();
      var grid = document.getElementById('registryItems');
      if (!grid) return;
      clearElement(grid);

      var filtered = items.filter(function (item) {
        var isFulfilled = item.quantity_fulfilled >= item.quantity_requested;
        if (activeFilter === 'all') return true;
        if (activeFilter === 'needed') return !isFulfilled;
        if (activeFilter === 'fulfilled') return isFulfilled;
        return true;
      });

      if (filtered.length === 0) {
        grid.textContent = 'No items to show.';
        return;
      }

      filtered.forEach(function (item) {
        var isFulfilled = item.quantity_fulfilled >= item.quantity_requested;
        var el = document.createElement('div');
        el.className = 'registry-item' + (isFulfilled ? ' fulfilled' : '');

        /* Image */
        if (item.image_url) {
          var imgWrap = document.createElement('div');
          imgWrap.className = 'registry-item__image';
          var img = document.createElement('img');
          img.src = item.image_url;
          img.alt = escapeHtml(item.title || '');
          img.loading = 'lazy';
          imgWrap.appendChild(img);
          if (isFulfilled) {
            var fulfilledBadge = document.createElement('span');
            fulfilledBadge.className = 'registry-item__fulfilled-badge';
            fulfilledBadge.textContent = 'Fulfilled';
            imgWrap.appendChild(fulfilledBadge);
          }
          el.appendChild(imgWrap);
        }

        /* Details */
        var details = document.createElement('div');
        details.className = 'registry-item__details';

        var title = document.createElement('p');
        title.className = 'registry-item__title';
        title.textContent = item.title || '';
        details.appendChild(title);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          var variant = document.createElement('p');
          variant.className = 'registry-item__variant';
          variant.textContent = item.variant_title;
          details.appendChild(variant);
        }

        if (item.price != null) {
          var price = document.createElement('p');
          price.className = 'registry-item__price';
          price.textContent = formatMoney(item.price);
          details.appendChild(price);
        }

        var qty = document.createElement('p');
        qty.className = 'registry-item__qty';
        qty.textContent = (item.quantity_fulfilled || 0) + ' of ' + (item.quantity_requested || 1) + ' fulfilled';
        details.appendChild(qty);

        if (item.priority && item.priority !== 'nice_to_have') {
          var priority = document.createElement('span');
          priority.className = 'registry-item__priority registry-item__priority--' + item.priority;
          priority.textContent = item.priority === 'must_have' ? 'Must Have' : 'Surprise Me';
          details.appendChild(priority);
        }

        /* Action: unified checkbox for all items */
        if (!isFulfilled) {
          var selectWrap = document.createElement('label');
          selectWrap.className = 'registry-item__select-wrap';
          var cb = document.createElement('input');
          cb.type = 'checkbox';
          cb.className = 'registry-item__select';
          cb.dataset.itemId = item.id;
          cb.dataset.variantId = item.shopify_variant_id || '';
          cb.dataset.variantTitle = item.variant_title || '';
          cb.dataset.productHandle = item.product_handle || '';
          cb.dataset.productTitle = item.title || '';
          selectWrap.appendChild(cb);
          selectWrap.appendChild(document.createTextNode(' Select to give'));
          details.appendChild(selectWrap);
        }

        el.appendChild(details);

        if (item.note) {
          var note = document.createElement('p');
          note.className = 'registry-item__note';
          note.textContent = item.note;
          el.appendChild(note);
        }

        grid.appendChild(el);
      });
    }

    function renderCartActions() {
      var actionsEl = document.getElementById('cartActions');
      if (!actionsEl) return;
      actionsEl.style.display = 'none';

      /* Show/hide cart actions when checkboxes change */
      container.addEventListener('change', function (e) {
        if (e.target && e.target.classList.contains('registry-item__select')) {
          var anyChecked = container.querySelector('.registry-item__select:checked');
          actionsEl.style.display = anyChecked ? '' : 'none';
        }
      });

      /* Add to cart button */
      var addBtn = document.getElementById('addSelectedToCart');
      if (addBtn) {
        addBtn.addEventListener('click', handleAddToCart);
      }
    }

    /* Match variant_title against a product's variants to find the ID */
    function matchVariantInProduct(product, variantTitle) {
      if (!product || !product.variants) return null;
      if (product.variants.length === 1) return product.variants[0].id;
      if (!variantTitle) return product.variants[0].id;

      var titleLower = variantTitle.toLowerCase().trim();
      var parts = titleLower.split(/\s*[\/,]\s*/);

      /* Exact match */
      for (var i = 0; i < product.variants.length; i++) {
        var vt = (product.variants[i].title || '').toLowerCase().trim();
        if (vt === titleLower) return product.variants[i].id;
      }
      /* All parts present */
      for (var j = 0; j < product.variants.length; j++) {
        var vtj = (product.variants[j].title || '').toLowerCase();
        var allMatch = true;
        for (var p = 0; p < parts.length; p++) {
          if (vtj.indexOf(parts[p]) === -1) { allMatch = false; break; }
        }
        if (allMatch) return product.variants[j].id;
      }
      /* Option values match */
      for (var k = 0; k < product.variants.length; k++) {
        var opts = [
          (product.variants[k].option1 || '').toLowerCase(),
          (product.variants[k].option2 || '').toLowerCase(),
          (product.variants[k].option3 || '').toLowerCase()
        ];
        var matchCount = 0;
        for (var pp = 0; pp < parts.length; pp++) {
          if (opts.indexOf(parts[pp]) > -1) matchCount++;
        }
        if (matchCount === parts.length) return product.variants[k].id;
      }
      /* Fallback: first available */
      for (var f = 0; f < product.variants.length; f++) {
        if (product.variants[f].available) return product.variants[f].id;
      }
      return product.variants[0].id;
    }

    /* Look up a Shopify variant ID — try product handle first, then search by title */
    function resolveVariantId(productHandle, variantTitle, productTitle) {
      /* Strategy 1: Fetch by handle */
      function tryHandle(handle) {
        if (!handle) return Promise.resolve(null);
        return fetch('/products/' + encodeURIComponent(handle) + '.js')
          .then(function (resp) {
            if (!resp.ok) return null;
            return resp.json();
          })
          .then(function (product) {
            return matchVariantInProduct(product, variantTitle);
          })
          .catch(function () { return null; });
      }

      /* Strategy 2: Search by product title */
      function searchByTitle(title) {
        if (!title) return Promise.resolve(null);
        var searchQ = encodeURIComponent(title.replace(/ by .*$/, ''));
        return fetch('/search/suggest.json?q=' + searchQ + '&resources[type]=product&resources[limit]=5')
          .then(function (resp) {
            if (!resp.ok) return null;
            return resp.json();
          })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            /* Find the product whose title best matches */
            var titleLower = title.toLowerCase();
            for (var i = 0; i < products.length; i++) {
              if (products[i].title.toLowerCase() === titleLower) {
                return tryHandle(products[i].handle);
              }
            }
            /* Partial match */
            for (var j = 0; j < products.length; j++) {
              if (products[j].title.toLowerCase().indexOf(titleLower.split(' by ')[0].toLowerCase()) > -1) {
                return tryHandle(products[j].handle);
              }
            }
            /* Use first result */
            if (products.length > 0) return tryHandle(products[0].handle);
            return null;
          })
          .catch(function () { return null; });
      }

      return tryHandle(productHandle).then(function (vid) {
        if (vid) return vid;
        /* Handle didn't work — search by product title */
        return searchByTitle(productTitle);
      });
    }

    function handleAddToCart() {
      var selected = container.querySelectorAll('.registry-item__select:checked');
      if (selected.length === 0) { alert('Please select at least one item.'); return; }

      /* Build list of items to add, resolving missing variant IDs */
      var itemsToAdd = [];
      selected.forEach(function (cb) {
        itemsToAdd.push({
          itemId: cb.dataset.itemId,
          variantId: cb.dataset.variantId || '',
          variantTitle: cb.dataset.variantTitle || '',
          productHandle: cb.dataset.productHandle || '',
          productTitle: cb.dataset.productTitle || ''
        });
      });

      /* Step 1: Resolve any missing variant IDs via Shopify product JSON or search */
      var resolveSequence = Promise.resolve();
      itemsToAdd.forEach(function (item) {
        if (!item.variantId) {
          resolveSequence = resolveSequence.then(function () {
            return resolveVariantId(item.productHandle, item.variantTitle, item.productTitle).then(function (vid) {
              if (vid) item.variantId = String(vid);
            });
          });
        }
      });

      resolveSequence.then(function () {
        /* Filter to items that now have a variant ID */
        var addable = itemsToAdd.filter(function (item) { return !!item.variantId; });

        if (addable.length === 0) {
          alert('Could not determine the product variants. Please try again.');
          return;
        }

        /* Step 2: Add each item to cart */
        var addSequence = Promise.resolve();
        var addedCount = 0;

        addable.forEach(function (item) {
          addSequence = addSequence.then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({
                id: Number(item.variantId),
                quantity: 1,
                properties: {
                  _registry_item_id: item.itemId,
                  _gift_for: (registryData.registry || registryData).registrant_name || ''
                }
              })
            }).then(function (resp) {
              if (!resp.ok) {
                console.warn('[Registry] Failed to add variant ' + item.variantId + ': ' + resp.status);
                return;
              }
              addedCount++;
              return resp.json();
            });
          });
        });

        return addSequence.then(function () {
          /* Save gift message */
          var giftMsg = document.getElementById('registryGiftMessage');
          if (giftMsg && giftMsg.value.trim()) {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ note: giftMsg.value.trim() })
            });
          }
        }).then(function () {
          if (addedCount > 0) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          } else {
            alert('Could not add items to cart. Please try again.');
          }
        });
      }).catch(function (err) {
        console.error('Cart add error:', err);
        alert('Could not add items to cart. Please try again.');
      });
    }

    loadRegistry();
  }

  /* ============================================================
     Add to Registry (PDP button)
     ============================================================ */

  function rebuildRegistryButton(wrapper) {
    /* Rebuild the registry button DOM using safe DOM methods.
       Needed when Shopify section re-render replaces the contents. */
    clearElement(wrapper);

    var triggerBtn = document.createElement('button');
    triggerBtn.type = 'button';
    triggerBtn.className = 'registry-add-trigger';
    triggerBtn.id = 'registryAddTrigger';
    triggerBtn.textContent = '\u2665 Add to Registry';
    wrapper.appendChild(triggerBtn);

    var dropdown = document.createElement('div');
    dropdown.id = 'registryAddDropdown';
    dropdown.className = 'registry-add-dropdown';
    dropdown.style.display = 'none';

    var list = document.createElement('div');
    list.className = 'registry-add-dropdown__list';
    list.id = 'registryDropdownList';
    dropdown.appendChild(list);

    var bundleMode = document.createElement('div');
    bundleMode.id = 'bundleModeSelect';
    bundleMode.className = 'registry-add-dropdown__bundle-mode';
    bundleMode.style.display = 'none';
    var bTitle = document.createElement('p');
    var bStrong = document.createElement('strong');
    bStrong.textContent = 'How should gifters buy this bundle?';
    bTitle.appendChild(bStrong);
    bundleMode.appendChild(bTitle);
    var labels = [
      { value: 'locked', text: ' Save my exact selections', checked: true },
      { value: 'open', text: ' Let gifter choose options', checked: false }
    ];
    labels.forEach(function (l) {
      var label = document.createElement('label');
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'bundle_mode';
      radio.value = l.value;
      if (l.checked) radio.checked = true;
      label.appendChild(radio);
      label.appendChild(document.createTextNode(l.text));
      bundleMode.appendChild(label);
    });
    dropdown.appendChild(bundleMode);

    var addBtn = document.createElement('button');
    addBtn.type = 'button';
    addBtn.className = 'btn btn--small';
    addBtn.id = 'registryAddConfirm';
    addBtn.textContent = 'Add';
    dropdown.appendChild(addBtn);

    wrapper.appendChild(dropdown);

    var msg = document.createElement('div');
    msg.id = 'registryAddMessage';
    msg.className = 'registry-add-message';
    msg.style.display = 'none';
    wrapper.appendChild(msg);

    wrapper.style.display = '';
  }

  function initRegistryAddButton() {
    var wrapper = document.getElementById('registryAddButton');
    if (!wrapper) return;

    var trigger = document.getElementById('registryAddTrigger');

    /* If wrapper exists but trigger is gone (section re-render replaced
       contents with price or other HTML), rebuild the inner DOM */
    if (!trigger) {
      rebuildRegistryButton(wrapper);
      trigger = document.getElementById('registryAddTrigger');
    }

    var dropdown = document.getElementById('registryAddDropdown');
    var listEl = document.getElementById('registryDropdownList');
    var bundleModeSelect = document.getElementById('bundleModeSelect');
    var confirmBtn = document.getElementById('registryAddConfirm');
    var messageEl = document.getElementById('registryAddMessage');
    var isBundle = wrapper.dataset.isBundle === 'true';

    function getMwShadowRoot() {
      var mwEl = document.querySelector('mw-bundle-product');
      return mwEl && mwEl.shadowRoot ? mwEl.shadowRoot : null;
    }

    function hasMageWorxBundle() {
      var shadow = getMwShadowRoot();
      if (shadow && shadow.querySelectorAll('.BundleProduct__Item').length > 0) return true;
      /* Fallback for non-shadow MageWorx */
      var mwContainer = document.querySelector('.mw-gp-container');
      if (mwContainer && mwContainer.children.length > 0) return true;
      return false;
    }

    function getBundleQtyInputs() {
      var inputs = [];
      /* Primary: Shadow DOM inside mw-bundle-product */
      var shadow = getMwShadowRoot();
      if (shadow) {
        shadow.querySelectorAll('input[type="number"]').forEach(function (el) { inputs.push(el); });
      }
      /* Fallback: regular DOM */
      if (inputs.length === 0) {
        document.querySelectorAll(
          '.mw-gp-container input[type="number"], ' +
          '.mw-gp-product-item input[type="number"]'
        ).forEach(function (el) { inputs.push(el); });
      }
      return inputs;
    }

    var registryMap = {};
    var isTrueBundle = false;
    registryFetch('/registries').then(function (data) {
      var registries = data.registries || data;
      if (!registries || registries.length === 0) return;
      wrapper.style.display = '';

      registries.forEach(function (reg) {
        registryMap[reg.id] = reg;
        var label = document.createElement('label');
        var radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'registry_id';
        radio.value = reg.id;
        label.appendChild(radio);
        label.appendChild(document.createTextNode(' ' + (reg.title || 'Untitled')));
        listEl.appendChild(label);
      });

      /* Bundle validation: start ENABLED. If MageWorx renders a bundle UI,
         then disable until qty > 0. This avoids blocking non-bundle products
         that happen to have the mw_grouped_product tag. */
      if (isBundle && trigger) {
        function checkBundleQty() {
          var inputs = getBundleQtyInputs();
          if (inputs.length === 0) return; /* MageWorx hasn't rendered yet or not a real bundle */

          /* MageWorx rendered — this IS a real bundle */
          if (!isTrueBundle) {
            isTrueBundle = true;
            /* Show bundle mode selection */
            if (bundleModeSelect) bundleModeSelect.style.display = '';
          }

          var hasQty = false;
          inputs.forEach(function (input) {
            if (parseInt(input.value, 10) > 0) hasQty = true;
          });
          if (hasQty) {
            trigger.classList.remove('registry-add-trigger--disabled');
            trigger.disabled = false;
          } else {
            trigger.classList.add('registry-add-trigger--disabled');
            trigger.disabled = true;
          }
        }

        /* Poll for MageWorx rendering and qty changes */
        setInterval(checkBundleQty, 1000);
        document.addEventListener('click', function () { setTimeout(checkBundleQty, 200); });
      }
    }).catch(function () {
      // not logged in or error — leave hidden
    });

    if (trigger) {
      trigger.addEventListener('click', function () {
        dropdown.style.display = dropdown.style.display === 'none' ? '' : 'none';
        if (isTrueBundle && bundleModeSelect) {
          bundleModeSelect.style.display = '';
        }
      });
    }

    function captureMageWorxConfig() {
      var config = { components: [], total_price: 0 };
      var shadow = getMwShadowRoot();
      var runningTotal = 0;

      if (shadow) {
        /* === Use Shadow DOM with MageWorx's clean class structure ===
           Each .BundleProduct__Item contains:
           - .BundleProduct__Title (component name)
           - .BundleProductSelect__Control (select with Shopify variant IDs)
           - input[type=number] (quantity)
           - .BundleProduct__Price (price)
           - img (product image) */

        var items = shadow.querySelectorAll('.BundleProduct__Item');
        items.forEach(function (item) {
          var qtyInput = item.querySelector('input[type="number"]');
          var qty = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
          if (qty === 0) return;

          var titleEl = item.querySelector('.BundleProduct__Title');
          var componentTitle = titleEl ? titleEl.textContent.trim() : '';

          var selects = item.querySelectorAll('.BundleProductSelect__Control, select');
          var variantId = '';
          var selectedOptions = [];
          selects.forEach(function (sel) {
            if (sel.selectedIndex >= 0) {
              selectedOptions.push(sel.options[sel.selectedIndex].textContent.trim());
              /* Only use value as variant ID if it's numeric (Shopify variant ID).
                 Some selects have text values like "Glacier" for color options. */
              if (/^\d+$/.test(sel.value)) {
                variantId = sel.value;
              }
            }
          });

          /* Get the component's own product handle (not the parent bundle) */
          var componentHandle = '';
          var productLink = item.querySelector('a[href*="/products/"]');
          if (productLink) {
            var href = productLink.getAttribute('href') || '';
            var handleMatch = href.match(/\/products\/([^?#/]+)/);
            if (handleMatch) componentHandle = handleMatch[1];
          }
          /* Fallback: derive handle from title */
          if (!componentHandle && componentTitle) {
            componentHandle = componentTitle.toLowerCase()
              .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
          }

          var priceEl = item.querySelector('.BundleProduct__Price');
          var componentPrice = 0;
          if (priceEl) {
            var pt = priceEl.textContent.replace(/[^0-9.]/g, '');
            componentPrice = Math.round(parseFloat(pt) * 100) || 0;
          }

          var imgEl = item.querySelector('img');
          var imageUrl = imgEl ? imgEl.src : '';

          runningTotal += componentPrice * qty;

          config.components.push({
            variant_id: variantId,
            quantity: qty,
            title: componentTitle,
            selected_option: selectedOptions.join(' / '),
            image_url: imageUrl,
            price: componentPrice,
            product_handle: componentHandle
          });
        });

      } else {
        /* === Fallback for non-shadow MageWorx === */
        var qtyInputs = getBundleQtyInputs();
        qtyInputs.forEach(function (qtyInput) {
          var qty = parseInt(qtyInput.value, 10) || 0;
          if (qty === 0) return;
          config.components.push({
            variant_id: '', quantity: qty, title: '',
            selected_option: '', image_url: '', price: 0
          });
        });
      }

      if (runningTotal > 0) config.total_price = runningTotal;

      return config;
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var selected = wrapper.querySelector('input[name="registry_id"]:checked');
        if (!selected) { alert('Please select a registry.'); return; }

        var registryId = selected.value;
        var productId = wrapper.dataset.productId;
        var productHandle = wrapper.dataset.productHandle || '';

        if (isTrueBundle) {
          /* BUNDLE: add each component with qty > 0 as a SEPARATE registry item */
          var bundleConfig = captureMageWorxConfig();
          var components = bundleConfig.components || [];

          if (components.length === 0) {
            alert('Please select a quantity for at least one product.');
            return;
          }

          var addSequence = Promise.resolve();
          var addedCount = 0;

          components.forEach(function (comp) {
            addSequence = addSequence.then(function () {
              /* Only use variant_id if it's numeric (MageWorx selects
                 may have option text like "Twin" instead of a Shopify variant ID) */
              var compVariantId = comp.variant_id;
              if (!compVariantId || !/^\d+$/.test(compVariantId)) {
                compVariantId = null;
              }
              var itemBody = {
                shopify_product_id: productId,
                shopify_variant_id: compVariantId,
                variant_title: comp.selected_option || '',
                title: comp.title || wrapper.dataset.productTitle || '',
                image_url: comp.image_url || wrapper.dataset.productImage || '',
                price: comp.price || 0,
                product_handle: comp.product_handle || productHandle,
                is_bundle: true,
                quantity_requested: comp.quantity || 1
              };
              return registryFetch('/registries/' + registryId + '/items', {
                method: 'POST',
                body: JSON.stringify(itemBody)
              }).then(function () { addedCount++; });
            });
          });

          addSequence.then(function () {
            dropdown.style.display = 'none';
            if (messageEl) {
              messageEl.textContent = addedCount + ' item' + (addedCount > 1 ? 's' : '') + ' added to registry! ';
              var reg = registryMap[registryId];
              if (reg && reg.slug) {
                var link = document.createElement('a');
                link.href = '/pages/view-registry?slug=' + encodeURIComponent(reg.slug);
                link.textContent = 'View Registry \u2192';
                messageEl.appendChild(link);
              }
              messageEl.style.display = '';
              setTimeout(function () { messageEl.style.display = 'none'; }, 5000);
            }
          }).catch(function (err) {
            if (messageEl) {
              messageEl.textContent = (err && err.error) || 'Failed to add items.';
              messageEl.style.background = '#f8d7da';
              messageEl.style.display = '';
            }
          });

        } else {
          /* STANDARD PRODUCT: add as single registry item */
          var currentVariantId = wrapper.dataset.variantId;
          var currentVariantTitle = '';

          /* Read variant from Expanse theme selectors */
          var variantInputs = document.querySelectorAll('[data-variant-input]');
          if (variantInputs.length > 0) {
            var parts = [];
            variantInputs.forEach(function (el) {
              if (el.tagName === 'SELECT') {
                parts.push(el.options[el.selectedIndex].textContent.trim());
              } else if (el.type === 'radio' && el.checked) {
                parts.push(el.value);
              }
            });
            if (parts.length > 0) currentVariantTitle = parts.join(' / ');
          }

          /* Read variant ID from hidden select */
          var variantSelect = document.querySelector('select[name="id"]');
          if (variantSelect && variantSelect.value) {
            currentVariantId = variantSelect.value;
            if (!currentVariantTitle) {
              var selectedOption = variantSelect.options ? variantSelect.options[variantSelect.selectedIndex] : null;
              if (selectedOption) {
                currentVariantTitle = selectedOption.textContent.trim()
                  .replace(/ - [\$\d,.]+.*$/, '').replace(/ - Sold Out$/, '');
              }
            }
          }
          if (currentVariantTitle === 'Default Title') currentVariantTitle = '';

          var body = {
            shopify_product_id: productId,
            shopify_variant_id: currentVariantId,
            variant_title: currentVariantTitle,
            title: wrapper.dataset.productTitle || '',
            image_url: wrapper.dataset.productImage || '',
            price: parseInt(wrapper.dataset.productPrice, 10) || 0,
            product_handle: productHandle,
            is_bundle: false
          };

          registryFetch('/registries/' + registryId + '/items', {
            method: 'POST',
            body: JSON.stringify(body)
          }).then(function () {
            dropdown.style.display = 'none';
            if (messageEl) {
              messageEl.textContent = 'Added to registry! ';
              var reg = registryMap[registryId];
              if (reg && reg.slug) {
                var link = document.createElement('a');
                link.href = '/pages/view-registry?slug=' + encodeURIComponent(reg.slug);
                link.textContent = 'View Registry \u2192';
                messageEl.appendChild(link);
              }
              messageEl.style.display = '';
              setTimeout(function () { messageEl.style.display = 'none'; }, 5000);
            }
          }).catch(function (err) {
            if (messageEl) {
              messageEl.textContent = (err && err.error) || 'Failed to add.';
              messageEl.style.background = '#f8d7da';
              messageEl.style.display = '';
            }
          });
        }
      });
    }
  }

  /* ============================================================
     Registry Banner (PDP — buying for a registry)
     ============================================================ */

  function initRegistryBanner() {
    var params = new URLSearchParams(window.location.search);
    var registryId = params.get('registry_id');
    var itemId = params.get('item_id');
    if (!registryId) return;

    var form = document.querySelector('.product-single__form');
    if (!form) return;

    // Insert banner above form
    var banner = document.createElement('div');
    banner.className = 'registry-banner';
    banner.textContent = 'You are purchasing this item for a gift registry.';
    form.parentNode.insertBefore(banner, form);

    // Inject hidden fields
    var fields = [
      { name: '_registry_id', value: registryId },
      { name: '_registry_item_id', value: itemId || '' },
      { name: '_is_bundle', value: params.get('is_bundle') || '' }
    ];
    fields.forEach(function (f) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + f.name + ']';
      input.value = f.value;
      form.appendChild(input);
    });
  }

  /* ============================================================
     Pre-select MageWorx bundle options from registry
     ============================================================ */

  function initRegistryPreselect() {
    var params = new URLSearchParams(window.location.search);
    if (!params.get('registry_preselect')) return;

    var regSlug = params.get('registry_slug');
    var itemId = params.get('registry_item_id');
    if (!regSlug || !itemId) return;

    /* Find where to insert the reference card */
    var form = document.querySelector('.product-single__form');
    if (!form) return;

    var card = document.createElement('div');
    card.className = 'registry-preselect-card';
    card.textContent = 'Loading registrant\u2019s selections...';
    form.parentNode.insertBefore(card, form);

    /* Fetch registry data */
    registryFetch('/r/' + encodeURIComponent(regSlug)).then(function (data) {
      var items = data.items || [];
      var item = null;
      for (var i = 0; i < items.length; i++) {
        if (items[i].id === itemId) { item = items[i]; break; }
      }

      clearElement(card);

      /* Header */
      var header = document.createElement('div');
      header.className = 'registry-preselect-card__header';
      header.textContent = '\ud83c\udf81 Gift Registry \u2014 Registrant\u2019s Selections';
      card.appendChild(header);

      var hint = document.createElement('p');
      hint.className = 'registry-preselect-card__hint';
      hint.textContent = 'Please match the selections below, then add to cart.';
      card.appendChild(hint);

      if (!item || !item.bundle_config || !item.bundle_config.components || item.bundle_config.components.length === 0) {
        /* No specific selections — show variant title if available */
        if (item && item.variant_title) {
          var row = document.createElement('div');
          row.className = 'registry-preselect-card__row';
          row.textContent = item.variant_title;
          card.appendChild(row);
        } else {
          hint.textContent = 'No specific selections recorded. Choose your options and add to cart.';
        }
        return;
      }

      /* Render each component as a row */
      var components = item.bundle_config.components;
      components.forEach(function (comp) {
        var row = document.createElement('div');
        row.className = 'registry-preselect-card__row';

        if (comp.image_url) {
          var img = document.createElement('img');
          img.src = comp.image_url;
          img.alt = '';
          img.className = 'registry-preselect-card__img';
          row.appendChild(img);
        }

        var info = document.createElement('div');
        info.className = 'registry-preselect-card__info';

        if (comp.title) {
          var name = document.createElement('strong');
          name.textContent = comp.title;
          info.appendChild(name);
        }

        if (comp.selected_option) {
          var opts = document.createElement('span');
          opts.className = 'registry-preselect-card__option';
          opts.textContent = comp.selected_option;
          info.appendChild(opts);
        }

        var meta = document.createElement('span');
        meta.className = 'registry-preselect-card__meta';
        var metaParts = [];
        if (comp.quantity) metaParts.push('Qty: ' + comp.quantity);
        if (comp.price) metaParts.push(formatMoney(comp.price));
        if (metaParts.length) {
          meta.textContent = metaParts.join(' \u00b7 ');
          info.appendChild(meta);
        }

        row.appendChild(info);
        card.appendChild(row);
      });

    }).catch(function () {
      card.textContent = 'Could not load registrant\u2019s selections.';
    });
  }

  /* ============================================================
     Init
     ============================================================ */

  document.addEventListener('DOMContentLoaded', function () {
    initRegistryForm();
    initRegistryManage();
    initRegistryFind();
    initRegistryView();
    initRegistryAddButton();
    initRegistryBanner();
    initRegistryPreselect();
  });

  /* Re-initialize the PDP button when Shopify re-renders a section
     (e.g. gift card variant change re-renders the product form) */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initRegistryAddButton, 500);
    setTimeout(initRegistryBanner, 500);
  });

  /* Watch for the registry button being removed and re-added after section re-render.
     The Expanse theme uses AJAX section rendering — the old DOM is replaced with new HTML.
     We poll for the new button to appear after detecting it was removed. */
  /* Watch for registry button disappearing after section re-render.
     Handles two cases:
     1. Wrapper exists but contents replaced (price overwrites button)
     2. Wrapper completely removed (full section re-render) */
  (function watchForReRender() {
    var hadButton = false;

    setInterval(function () {
      try {
        var trigger = document.getElementById('registryAddTrigger');
        var wrapper = document.getElementById('registryAddButton');

        if (trigger) {
          hadButton = true;
          return;
        }

        if (!hadButton) return;

        /* Button was there before but trigger is gone now */
        if (wrapper && !trigger) {
          /* Case 1: wrapper exists but contents replaced — rebuild */
          hadButton = false;
          initRegistryAddButton();
        } else if (!wrapper) {
          /* Case 2: wrapper completely removed — wait for it to reappear */
          hadButton = false;
          var attempts = 0;
          var poll = setInterval(function () {
            attempts++;
            var newWrapper = document.getElementById('registryAddButton');
            if (newWrapper) {
              clearInterval(poll);
              initRegistryAddButton();
            } else if (attempts > 20) {
              clearInterval(poll);
            }
          }, 500);
        }
      } catch (e) {
        /* Ignore errors from concurrent DOM changes */
      }
    }, 500);
  })();

})();
